import {useRef} from "react";
import {pressEnter} from "../../utils/events";

/**
 * テキスト入力のカスタマイズ版
 * ※ enterイベントに対応（日本語入力中のEnterを除外する）
 * @returns {JSX.Element}
 */
const CustomInput = ({
                        name,
                        id = "",
                        value,
                        type = "text",
                        className,
                        onEnterKey = () => {},
                        setValue = (e) => {},
                        placeholder = ""
                      }) => {
  const composing = useRef(false);

  return (
    <input className={className}
           id={id}
           name={name}
           value={value}
           type={type} placeholder={placeholder}
           onChange={(e) => {
             setValue(e.target.value);
           }}
           onKeyDown={(e) => {
             pressEnter(e, () => {
               if (composing.current) return;
               // noinspection JSCheckFunctionSignatures
               onEnterKey(e);
             })
           }}
    />
  )
}
export default CustomInput;